/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalization.rpc.RecommendationAppRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './RecommendationAppRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalization.rpc.RecommendationAppRpc#getInferenceHubTier
 */
export const GET_INFERENCE_HUB_TIER_QUERY_FIELD_NAME = 'com_hubspot_personalization_rpc_RecommendationAppRpc_getInferenceHubTier';
export const GET_INFERENCE_HUB_TIER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INFERENCE_HUB_TIER_QUERY_FIELD_NAME,
  args: ['allowedHubs', 'allowedTiers'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getInferenceHubTierRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalization.rpc.RecommendationAppRpc#getInferenceForPricingRedirect
 */
export const GET_INFERENCE_FOR_PRICING_REDIRECT_QUERY_FIELD_NAME = 'com_hubspot_personalization_rpc_RecommendationAppRpc_getInferenceForPricingRedirect';
export const GET_INFERENCE_FOR_PRICING_REDIRECT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INFERENCE_FOR_PRICING_REDIRECT_QUERY_FIELD_NAME,
  args: ['allowedHubs', 'allowedTiers'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getInferenceForPricingRedirectRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});